import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import ContentWrap from '../components/content-wrap/ContentWrap';
import CollapsiblePanel from '../components/collapsible-panel/CollapsiblePanel';
import ProjectInfo from './project-info/ProjectInfo';
import DeliveryZones from './delivery-zones/DeliveryZones';
import ProjectSettingsContent from './project-settings-content/ProjectSettingsContent';
import { SettingsExpanded } from '../../core/types/settings/SettingsExpanded';
import BlockBookingSlots from './block-booking-slots/BlockBookingSlots';
import { RootState } from '../../core/state/state';
import { getProjectContacts } from '../../core/state/project/asyncActions';

import './ProjectSettings.scss';

const ProjectSettings: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isExpanded, setExpanded] = useState<SettingsExpanded>({ settings: false, projectInfo: false });
  const contacts = useSelector((state: RootState) => state.projects.projectContacts);
  const { projectId } = useParams<{ projectId: string }>();

  React.useEffect(() => {
    dispatch(getProjectContacts(Number(projectId)));
  }, [dispatch, projectId]);

  return (
    <div className="project-settings">
      <ContentWrap>
        <CollapsiblePanel
          title={t('projectSettings.info.title')}
          expanded={isExpanded.projectInfo}
          onExpandChange={(expanded) => setExpanded({ ...isExpanded, projectInfo: expanded })}
        >
          <div className="project-settings__inner">
            {contacts && <ProjectInfo contacts={contacts} isExpanded={isExpanded} setExpanded={setExpanded} />}
          </div>
        </CollapsiblePanel>
        <CollapsiblePanel
          title={t('projectSettings.settings.title')}
          expanded={isExpanded.settings}
          onExpandChange={(expanded) => setExpanded({ ...isExpanded, settings: expanded })}
        >
          <div className="project-settings__inner">
            <ProjectSettingsContent isExpanded={isExpanded} setExpanded={setExpanded} />
          </div>
        </CollapsiblePanel>
        <CollapsiblePanel title={t('projectSettings.deliveryZones.title')}>
          <DeliveryZones />
        </CollapsiblePanel>
        <CollapsiblePanel title={t('projectSettings.blockBookingSlots.title')} expanded>
          <BlockBookingSlots />
        </CollapsiblePanel>
      </ContentWrap>
    </div>
  );
};

export default ProjectSettings;
